import { useRoutes, Navigate } from "react-router-dom";
import MainRoutes from "./main-routes";
import Signin from "../pages/auth/signin";
import Password from "../pages/auth/create-password";
import ForgotPassword from "../pages/auth/forgot-password";
import ResetPassword from "../pages/auth/reset-password";

// ================|| ROUTING RENDER ||================ //

export default function ThemeRoutes() {
  return useRoutes([
    ...MainRoutes,
    { path: "/signin", element: <Signin /> },
    { path: "/set-password/:id", element: <Password /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/reset-password/:id", element: <ResetPassword /> },
    { path: "/users", element: <Navigate to="/dashboard/users" replace /> },
    {
      path: "/customers",
      element: <Navigate to="/dashboard/customers" replace />,
    },
    {
      path: "/inventory",
      element: <Navigate to="/dashboard/inventory" replace />,
    },
    { path: "/orders", element: <Navigate to="/dashboard/orders" replace /> },
  ]);
}
